import React from "react"
export const ProfileImage = ({ image }) => (
    <img src={image} className="profile-image" alt="" />
)
